import { initAdminGhostCoversPage } from './admin-ghost-covers/controller.js';

initAdminGhostCoversPage();
